import { render, staticRenderFns } from "./PolizasRHListView.vue?vue&type=template&id=20b5f840&"
import script from "./PolizasRHListView.vue?vue&type=script&lang=js&"
export * from "./PolizasRHListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports